import './component-cart-bundle.scss';

export default class CartBundle extends HTMLElement {
    constructor() {
        super();

        this.cartElement = false;
        this.currentBundleOverlay = this;
        this.bundleUpdatesArray;
        this.currencySymbol;
        this.hasSubscriptions = false;
        this.currentSellingPlan = false;
        this.isMainCart = false;
        this.minSpendWarningActive = false;

        this.getCartInstance();
    }

    /**
     * getCartInstance ()
     *
     * Check for mini cart and assign cart element for firing cart requests 
    */
    getCartInstance () {
        const cartNotification = document.querySelector('cart-notification');
        const cartItems =  document.querySelector('cart-items');
        if (cartNotification) {
            this.cartElement = cartNotification;
        } else {
            this.cartElement = cartItems;
            this.isMainCart = true;
        }
    }

    /**
     * initEventListeners ()
     *
     * Init event listeners when HTTP request and DOM parser have returned dom nodes
    */
    initEventListeners() {
        // Bundle overlay trigger
        const parentEl = this.isMainCart ? this.currentBundleOverlay.closest('.cart-item') : this.currentBundleOverlay.closest('.cart-notification-product__item');
        parentEl.querySelectorAll('.js-toggle-bundle-overlay').forEach((bundleBtn) => {
            bundleBtn.addEventListener('click', (e) => {
                this.toggleBundleOverlay(e);
            })
        })

        // Bundle overlay quantity change
        this.currentBundleOverlay.querySelectorAll('.js-bundle-overlay-quantity-change').forEach((qtyBtn) => {
            qtyBtn.addEventListener('click', (e) => {
                let qtyValue = parseFloat(qtyBtn.dataset.quantity);
                const productWrap = qtyBtn.closest('.js-bundle-overlay-item');
                const quantityWrap = qtyBtn.closest('.quantity');
                const quantityText = quantityWrap.querySelector('.quantity__input');
                const quanitityBtns = quantityWrap.querySelectorAll('button');
                const priceEl = qtyBtn.closest('.cart-notification-product__item').querySelector('.js-bundle-overlay-item-price');

                // Handle quantity value change
                if (!qtyBtn.hasAttribute('data-decrease') || qtyBtn.hasAttribute('data-decrease') && qtyValue > 0) {
                    qtyBtn.hasAttribute('data-decrease') ? qtyValue -= 1 : qtyValue += 1;
                    quanitityBtns.forEach(btn => {
                        btn.dataset.quantity = qtyValue;
                    })
                    quantityText.innerHTML = qtyValue;
                    this.handleBundleProductDisabledToggle(qtyValue, productWrap);
                }

                // Update bundleUpdates to use when user clicks save
                const currentIndex = this.bundleUpdatesArray.findIndex(update => update.id === qtyBtn.dataset.id);
                this.bundleUpdatesArray[currentIndex].quantity = qtyValue;

                this.handleBundlePriceUpdates(priceEl, qtyValue);

                e.preventDefault();
            })
        })

        // Bundle overlay remove 
        this.currentBundleOverlay.querySelectorAll('.js-bundle-overlay-remove').forEach((removeBtn) => {
            removeBtn.addEventListener('click', (e) => {
                const productWrap = removeBtn.closest('.js-bundle-overlay-item');
                const quantityWrap = removeBtn.parentElement.previousElementSibling;
                const quantityText = quantityWrap.querySelector('.quantity__input');
                const quanitityBtns = quantityWrap.querySelectorAll('button');
                const priceEl = removeBtn.closest('.cart-notification-product__item').querySelector('.js-bundle-overlay-item-price');
                
                // Update quantity buttons
                quanitityBtns.forEach(btn => btn.dataset.quantity = 0)
                quantityText.innerHTML = 0;
                
                // Update bundleUpdates to use when user clicks save
                const currentIndex = this.bundleUpdatesArray.findIndex(update => update.id === removeBtn.dataset.id);
                this.bundleUpdatesArray[currentIndex].quantity = 0;

                this.handleBundlePriceUpdates(priceEl, 0);

                this.handleBundleProductDisabledToggle(0, productWrap);

                e.preventDefault();
            })
        })

        // Bundle overlay selling plan select
        this.currentBundleOverlay.querySelectorAll('.js-bundle-overlay-select-plan').forEach((selectPlan) => {
            selectPlan.addEventListener('change', (e) => {
                if (this.currentSellingPlan !== e.target.value) {
                    this.bundleUpdatesArray.forEach((product) => {
                        product.selling_plan = e.target.value;
                    })
                }
                
                // Enable save button
                if (!this.minSpendWarningActive) {
                    this.currentBundleOverlay.querySelector('.js-bundle-overlay-save').disabled = false;
                }

                // Changing the plan and clicking save will lose the
                // compare price due to no price calcs being made so set it here
                if (!this.bundleUpdatesArray[0]?.properties?._bundle_compare_at_price) {
                    const currentCompareTotal = document.querySelector('.js-bundle-overlay-compare-total');
                    this.bundleUpdatesArray.forEach((product) => {
                        product.properties._bundle_compare_at_price = currentCompareTotal.innerHTML;
                    })
                }

                e.preventDefault();
            })
        })

        // Bundle overlay save
        this.currentBundleOverlay.querySelectorAll('.js-bundle-overlay-save').forEach((bundleSave) => {
            bundleSave.addEventListener('click', (e) => {
                const lineItems = this.currentBundleOverlay.dataset.cartLineItems;

                this.cartElement.updateBundle(lineItems, this.bundleUpdatesArray, this.currentBundleOverlay);

                e.preventDefault();
            })
        })
    }

    toggleBundleOverlay (button) {
        this.setBundlesArray();

        if (this.currentBundleOverlay.classList.contains('medium:translate-x-full')) {
            this.currentBundleOverlay.classList.remove('mediumMax:translate-y-full');
            this.currentBundleOverlay.classList.remove('medium:translate-x-full');
            this.currentBundleOverlay.classList.add('mediumMax:translate-y-0');
            this.currentBundleOverlay.classList.add('medium:translate-x-0');
            this.storeOverlayBundleValues();
        } else {
            this.currentBundleOverlay.classList.remove('mediumMax:translate-y-0');
            this.currentBundleOverlay.classList.remove('medium:translate-x-0');
            this.currentBundleOverlay.classList.add('mediumMax:translate-y-full');
            this.currentBundleOverlay.classList.add('medium:translate-x-full');
            this.resetOverlayBundleValues();
        }

        // Toggle overlay background when on main cart
        if (this.isMainCart) {
            if (document.body.classList.contains('is-hidden')) {
                document.body.classList.remove('is-hidden');
                document.body.classList.remove('overflow-hidden');
            } else {
                document.body.classList.add('is-hidden');
                document.body.classList.add('overflow-hidden');
            }
        }

        button.preventDefault();
    }

    /**
     * handleBundlePriceUpdates ()
     *
     * Handle total and line item price updates for bundle overlay
    */
    handleBundlePriceUpdates(linePriceEl, newQuantity) {
        let newTotal = 0;
        let newCompareTotal = 0;

        // Enable save button
        this.currentBundleOverlay.querySelector('.js-bundle-overlay-save').disabled = false;

        // Get currency symbol
        const currencySymbol = this.getCurrencySymbol(linePriceEl);
        this.currencySymbol = currencySymbol;

        // Update line price data and HTML
        const newPrice = parseFloat(linePriceEl.dataset.singlePrice) * newQuantity;
        linePriceEl.innerHTML = `${(newPrice / 100).toFixed(2).replace('.', ',')}${currencySymbol}`;
        linePriceEl.dataset.currentPrice = newPrice;
        linePriceEl.dataset.compareLinePrice =  parseFloat(linePriceEl.dataset.comparePrice) * newQuantity;

        // Total of all line price and line compare prices
        this.currentBundleOverlay.querySelectorAll('.js-bundle-overlay-item-price').forEach(price => {
            newTotal += parseFloat(price.dataset.currentPrice);
            newCompareTotal += parseFloat(price.dataset.compareLinePrice);
        })

        // Update HTML and data attributes for totals
        const totalPriceEl = this.currentBundleOverlay.querySelector('.js-bundle-overlay-total');
        const totalComparePriceEl = this.currentBundleOverlay.querySelector('.js-bundle-overlay-compare-total');
        const bundleOverlayCompareTotal = `${(newCompareTotal / 100).toFixed(2).replace('.', ',')}${currencySymbol}`;
        totalPriceEl.innerHTML = `${(newTotal / 100).toFixed(2).replace('.', ',')}${currencySymbol}`;
        if (totalComparePriceEl) {
            totalComparePriceEl.innerHTML = bundleOverlayCompareTotal;
        }
        this.bundleUpdatesArray.forEach((product) => {
            product.properties._bundle_compare_at_price = bundleOverlayCompareTotal
        })

        // Hide compare price if no longer more than total
        if (newTotal < newCompareTotal) {
            if (totalComparePriceEl && totalComparePriceEl.classList.contains('hidden')) {
                totalComparePriceEl.classList.remove('hidden')
            }
        } else {
            totalComparePriceEl?.classList.add('hidden')
        }

        this.handleMinSpendWarning(newTotal);
    }

    /**
     * getCurrencySymbol ()
     *
     * No reliable way to get currency symbol so get it from liquid money price
    */
    getCurrencySymbol (price) {
        const isNumeric = (string) => /^[+-]?\d+(\.\d+)?$/.test(string)
        const linePriceLength = price.dataset.moneyPrice.length - 1;
        return isNumeric(price.dataset.moneyPrice.charAt(0)) ? 
            price.dataset.moneyPrice.charAt(linePriceLength) :
            price.dataset.moneyPrice.charAt(0);
    }

    /**
     * setBundlesArray ()
     *
     * Store bundle array for updating selling plan and reset values when overlay opened
    */
    setBundlesArray () {
        const dateTime = new Date();
        const dateNow = dateTime.toLocaleTimeString();
        const newBundleArray = [];
        const sellingPlan = this.currentBundleOverlay.querySelector('.js-bundle-overlay-select-plan').value;

        this.currentBundleOverlay.querySelectorAll('.js-bundle-overlay-item').forEach(product => {
            newBundleArray.push({
                id: product.dataset.id,
                quantity: product.dataset.quantity,
                selling_plan: sellingPlan,
                properties: {
                    '_is_subscription_bundle': true,
                    '_timestamp': dateNow,
                    '_bundle_compare_at_price': false
                }
            })
        })

        this.bundleUpdatesArray = newBundleArray;
        this.currentSellingPlan = sellingPlan;
    }

    /**
     * storeOverlayBundleValues ()
     *
     * Store bundle overly values to reset if overlay closed
    */
    storeOverlayBundleValues () {
        const productData = [];
        const totalPriceEl = this.currentBundleOverlay.querySelector('.js-bundle-overlay-total');
        const totalComparePriceEl = this.currentBundleOverlay.querySelector('.js-bundle-overlay-compare-total');

        this.currentBundleOverlay.querySelectorAll('.js-bundle-overlay-item').forEach(item => {
            productData.push(
                {
                    key: item.dataset.key,
                    quantity: item.dataset.quantity,
                    originalPrice: item.dataset.price
                }
            )
        })

        this.bundleInitialValues = { products: productData, total: totalPriceEl?.innerHTML, compareTotal: totalComparePriceEl?.innerHTML }
    }

    /**
     * resetOverlayBundleValues ()
     *
     * Use stored initial values to reset if the overlay is closed
    */
    resetOverlayBundleValues () {
        const totalPrice = this.currentBundleOverlay.querySelector('.js-bundle-overlay-total');
        const totalComparePriceEl = this.currentBundleOverlay.querySelector('.js-bundle-overlay-compare-total');

        this.currentBundleOverlay.querySelectorAll('.js-bundle-overlay-item').forEach(item => {
            const initialValues = this.bundleInitialValues.products?.find(storedValue => storedValue.key === item.dataset.key);
            item.querySelectorAll('.js-bundle-overlay-quantity-change').forEach(btn => btn.dataset.quantity = initialValues.quantity);
            item.querySelector('.js-bundle-overlay-quantity-input').innerHTML = initialValues.quantity;
            item.querySelectorAll('.js-bundle-overlay-item-price').forEach(price => {
                price.innerHTML = price.dataset.moneyLinePrice;
                price.dataset.currentPrice = initialValues.originalPrice;
            });
        })

        this.hideMinSpendWarning();
        this.resetBundleProductsDisabled();

        this.currentBundleOverlay.querySelector('.js-bundle-overlay-save').disabled = true;

        totalPrice.innerHTML = this.bundleInitialValues.total;
        if (totalComparePriceEl) {
            totalComparePriceEl.innerHTML = this.bundleInitialValues.compareTotal;
        }
    }

    /**
     * handleMinSpendWarning ()
     *
     * Show/Hide min spend warning when bundle price updated
    */
    handleMinSpendWarning (newTotal) {
        const minSpendEl = this.currentBundleOverlay.querySelector('.js-bundle-overlay-min-spend');
        const productWrap = this.currentBundleOverlay.querySelector('.js-overlay-bundle-products-wrap');
        const saveBtn = this.currentBundleOverlay.querySelector('.js-bundle-overlay-save');

        if (window.bundleMinSpend > (newTotal / 100)) {
            minSpendEl.classList.remove('opacity-0');
            minSpendEl.classList.add('translate-y-full');
            minSpendEl.classList.add('opacity-100');
            productWrap.classList.add('pt-20');
            saveBtn.disabled = true;
            this.minSpendWarningActive = true;

            this.handleMinSpendText(newTotal);
        } else {
            minSpendEl.classList.add('opacity-0');
            minSpendEl.classList.remove('translate-y-full');
            minSpendEl.classList.remove('opacity-100');
            productWrap.classList.remove('pt-20');
            saveBtn.disabled = false;
            this.minSpendWarningActive = false;
        }
    }

    /**
     * handleMinSpendWarning ()
     *
     * Hide min spend warning when bundle closed
    */
    hideMinSpendWarning () {
        const minSpendEl = this.currentBundleOverlay.querySelector('.js-bundle-overlay-min-spend');
        const productWrap = this.currentBundleOverlay.querySelector('.js-overlay-bundle-products-wrap');

        if (minSpendEl.classList.contains('opacity-100')) {
            minSpendEl.classList.add('opacity-0');
            minSpendEl.classList.remove('translate-y-full');
            minSpendEl.classList.remove('opacity-100');
            productWrap.classList.remove('pt-20');
        }
    }

    /**
     * handleMinSpendText ()
     *
     * Use theme settings saved to window to generate
     * min spend text and remaining price calc
    */
    handleMinSpendText (total) {
        const amountFromMinSpend = window.bundleMinSpend - (total / 100);
        const minSpendTextEl = this.currentBundleOverlay.querySelector('.js-bundle-overlay-min-spend-text');
        minSpendTextEl.innerHTML = `${window.bundleMinSpendTextBefore} ${window.bundleMinSpend}${this.currencySymbol}. ${window.bundleMinSpendTextAfter.replace(/\[.*?\]/, `${amountFromMinSpend.toFixed(2)}${this.currencySymbol}`)}`;
    }

    /**
     * handleBundleProductDisabledToggle ()
     *
     * Toggle product disabled when quantity is 0
    */
    handleBundleProductDisabledToggle (qtyVal, productEl) {
        const image = productEl.querySelector('.js-bundle-overlay-image');
        const content = productEl.querySelector('.js-bundle-overlay-content');
        const removeBtn = productEl.querySelector('.js-bundle-overlay-remove');

        if (qtyVal === 0 && !image.classList.contains('opacity-30')) {
            image.classList.add('opacity-30');
            content.classList.add('opacity-30');
            removeBtn.classList.add('opacity-0');
            removeBtn.classList.add('pointer-events-none');
        } else if (image.classList.contains('opacity-30')) {
            image.classList.remove('opacity-30');
            content.classList.remove('opacity-30');
            removeBtn.classList.remove('opacity-0');
            removeBtn.classList.remove('pointer-events-none');
        }
    }

    /**
     * handleBundleProductDisabledToggle ()
     *
     * Reset all product disabled states when overlay closed
    */
    resetBundleProductsDisabled () {
        const products = this.currentBundleOverlay.querySelectorAll('.js-bundle-overlay-item');
        products.forEach(item => {
            const image = item.querySelector('.js-bundle-overlay-image');
            const content = item.querySelector('.js-bundle-overlay-content');
            const removeBtn = item.querySelector('.js-bundle-overlay-remove');
            image.classList.remove('opacity-30');
            content.classList.remove('opacity-30');
            removeBtn.classList.remove('opacity-0');
            removeBtn.classList.remove('pointer-events-none');
        })
    }
}
